import {
  DEVELOPMENT_MANDATE_SECTIONS,
  type DevelopmentMandateSelections,
} from '@/config/developmentMandate';

export function formatEffectiveMandateSummary(
  mandate: DevelopmentMandateSelections | null | undefined,
): { section: string; labels: string }[] {
  if (!mandate) return [];
  return DEVELOPMENT_MANDATE_SECTIONS.map((section) => {
    const values = mandate[section.key] ?? [];
    if (!values.length) return null;
    const labels = values
      .map((v) => section.options.find((o) => o.value === v)?.label ?? v)
      .join(', ');
    return { section: section.title, labels };
  }).filter((row): row is { section: string; labels: string } => row !== null);
}
